import React, { useCallback, useRef } from 'react'

import cx from 'classnames'
import { CallHistoryMethodAction } from 'connected-react-router'
import { getCurrentUserId } from 'conversations/modules/user/selectors'
import { usePopper } from 'react-popper'
import { useDispatch, useSelector } from 'react-redux'
import { Dispatch } from 'redux'
import { updateConvoSidebarSectionAsync } from 'shared/store/actions/user/sections'
import { ConversationSidebarSectionConfig } from 'shared/typings/conversationsSidebar/Filters'

import { RootAction, RootState } from 'typesafe-actions'

import styles from './styles.module.css'

interface Props {
  children: JSX.Element
  sectionConfig?: ConversationSidebarSectionConfig
  active: boolean
  setActive: (active: boolean) => void
  onSectionLengthChange: (length: number) => void
}

export const ConversationsSectionsLengthListMenu: React.FC<Props> = ({
  children,
  active,
  setActive,
  sectionConfig,
  onSectionLengthChange,
}) => {
  const referenceElem = useRef<HTMLDivElement | null>(null)
  const popperElem = useRef<HTMLDivElement | null>(null)
  const dispatch = useDispatch<Dispatch<RootAction | CallHistoryMethodAction>>()
  const currentUserId = useSelector<RootState, number | undefined>(getCurrentUserId)

  const {
    styles: popperStyles,
    attributes,
    forceUpdate,
  } = usePopper(referenceElem.current, popperElem.current, {
    placement: 'bottom-start',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [200, -22],
        },
      },
    ],
  })

  const onEditSectionLength = useCallback(
    (length: number) => {
      onSectionLengthChange(length)
      currentUserId &&
        sectionConfig &&
        dispatch(
          updateConvoSidebarSectionAsync.request({
            config: {
              ...sectionConfig,
              sectionLength: length,
            },
            hideToast: true,
          })
        )
    },
    [dispatch, currentUserId, sectionConfig, onSectionLengthChange]
  )

  return (
    <>
      <div
        ref={referenceElem}
        onClick={(e) => {
          forceUpdate && forceUpdate()
          setActive(true)
          e.stopPropagation()
        }}>
        {children}
      </div>
      <div
        ref={popperElem}
        className={cx({ [styles.hiddenStyle]: !active })}
        style={popperStyles.popper}
        {...attributes.popper}>
        <div className={cx(styles.menu)}>
          <div
            className={cx(styles.item)}
            onClick={() => {
              setActive(false)
              onEditSectionLength(3)
            }}>
            3 conversations
          </div>
          <div
            className={cx(styles.item)}
            onClick={() => {
              setActive(false)
              onEditSectionLength(5)
            }}>
            5 conversations
          </div>
          <div
            className={cx(styles.item)}
            onClick={() => {
              setActive(false)
              onEditSectionLength(10)
            }}>
            10 conversations
          </div>
        </div>
      </div>
    </>
  )
}
